import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'
import Container from '@/components/Placeholders/Container/Container.vue'

@Component({
    components: { Container },
    mixins: [ProjectMixin],
})
export default class SettingsIndex extends Mixins<MixinInterface>(ProjectMixin) {
    loaded = false
    accessible = true
    error: any = null

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get permissions() {
        let permissions: Array<any> = []
        Object.values(this.$store.getters.projects).map((project: any) => {
            permissions = [...permissions, ...project.attributes.permissions]
        })
        return permissions
    }

    get hasAdmin() {
        return this.hasPermission(this.permissions, 'admin')
    }

    get hasManage() {
        return this.hasPermission(this.permissions, 'manage')
    }

    get hasDelegate() {
        return this.hasPermission(this.permissions, 'delegate_access')
    }

    get hasGroup() {
        let res = false
        if (this.group?.attributes?.constraints) {
            Object.values(this.group.attributes.constraints).map((constraint: any) => {
                constraint.writable ? (res = true) : ''
            })
        }
        return res
    }

    async created() {
        if (this.project) {
            this.accessible = this.hasAdmin || this.hasManage || this.hasDelegate
        }

        if (this.group) {
            this.accessible = this.hasGroup || this.hasAdmin || this.hasManage || this.hasDelegate
        }

        this.loaded = true
    }
}
